import { Component } from '@angular/core';
import { Project } from 'src/app/models/project';
import { ServiceManager } from 'src/app/services/configurators-2d/service-manager';
import { ModalService } from '../../services/modal.service';
import { ProjectService } from '../../services/project.service';
import { CustomerService } from 'src/app/services/customer.service';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { environment } from 'src/environments/environment';
import { KitchenService } from 'src/app/services/configurators-2d/applications/kitchen.service';
import { StorageService } from '../../services/configurators-2d/applications/storage.service';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { BathroomService } from 'src/app/services/configurators-2d/applications/bathroom.service';

@Component({
  selector: 'ng-casto-project-delete',
  templateUrl: './project-delete.component.html',
})
export class ProjectDeleteComponent {
  isLoading: boolean = false;
  onClose: any;
  project: Project;

  constructor(
    public modal: ModalService,
    private projectService: ProjectService,
    private serviceManager: ServiceManager,
    private customerService: CustomerService,
    private kitchenService: KitchenService,
    private storageService: StorageService,
    private bathroomService: BathroomService
  ) {
    this.project = this.modal.currentDatas.project;
    this.onClose = this.modal.currentDatas.onClose;
  }

  async confirm() {
    this.isLoading = true;
    try {
      if (this.project.distributionID == environment.byMe.kitchen.distribID) {
        //Si kitchen//on recupere le KitchenService
        let kitchenConfig = await this.kitchenService.getLiteKitchenConfiguration(this.project.projectUUID);

        if (kitchenConfig?.workbenchConfigurationId) {
          const workbenchService = this.serviceManager.getService(CONFIG_CONTEXT.WORKBENCH); //on recupere le WorkbenchService
          await workbenchService.deleteProjectById(kitchenConfig?.workbenchConfigurationId);
        }

        await this.kitchenService.deleteKitchen({
          tunnelConfigurationId: kitchenConfig?.id,
        }); //On supprime la config

        await this.projectService.delete(
          //On supprime le projet byme
          this.project.projectID,
          this.project.extraDatas.isLegacy
        );
      } else if (this.project.distributionID == environment.byMe.storage.distribID) {
        let storageConfig = await this.storageService.getLiteStorageConfiguration(this.project.projectUUID);

        await this.storageService.deleteStorage({
          tunnelConfigurationId: storageConfig?.id,
        }); //On supprime la config

        await this.projectService.delete(
          //On supprime le projet byme
          this.project.projectID,
          this.project.extraDatas.isLegacy
        );
      } else if (this.project.distributionID == CONFIG_CONTEXT.BATHROOM_V2) {
        await this.bathroomService.deleteBathroom(this.project.projectID); //On supprime la config
      } else {
        //Sinon on fait le fonctionnement classique
        const service = this.serviceManager.getService(this.project.distributionID);
        if (service) {
          await service.deleteProjectById(this.project.projectID);
        } else {
          await this.projectService.delete(this.project.projectID, this.project.extraDatas.isLegacy);
        }
      }
    } catch (error) {
      logError(error);
    } finally {
      this.isLoading = false;
      this.close(true);
    }
  }

  cancel() {
    this.close(false);
  }

  private close(projectDeleted: boolean): void {
    this.modal.close(projectDeleted);
    if (this.onClose) {
      this.onClose(projectDeleted);
    }
  }
}
